// GENERATED by scripts/write-build-info.mjs - do not edit, not committed.
export const APP_VERSION = "1.2.8";
export const APP_COMMIT = "4c9e468";
